<div class="row">
  <mat-card class="community-card col-12 box-shadow">
      <mat-card-header class="row">
        <mat-card-title class="col-11">CCHVC</mat-card-title>
        <mat-card-subtitle class="col-12">TERRITOIRE DE LA COMMUNAUTE DE COMMUNES DE LA HAUTE VALLEE DE CHEVREUSE - CCHVC</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content >
        <div class="row">
          <div class="col-4">
            <div class="row">
              <h4 color="warm" class="col-12  mat-button mat-primary">
                Main Info
              </h4>
              <p class="col-12">
                  Lorem ipsum dolor sit amet
              </p>
            </div>
          </div>
          <div class="col-4">
              <div class="row">
                <h4 color="warm" class="col-12  mat-button mat-primary">
                  Main Info
                </h4>
                <p class="col-12">
                    Lorem ipsum dolor sit amet
                </p>
              </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <h4 color="warm" class="col-12  mat-button mat-primary">
                      Main Info
                    </h4>
                    <p class="col-12">
                        Lorem ipsum dolor sit amet
                    </p>
                  </div>
              </div>
            </div>
      </mat-card-content>

      <img class="com-img" mat-card-image src="../../assets/offline-img/IMG_9343.JPG" >
      <mat-card-actions>
        <div  class="row justify-content-around">
            <div class="col-3">
                <button mat-flat-button>retour</button>
            </div>
            <div class="col-3">
                <button mat-flat-button color="primary">Je m'inscris</button>
            </div>

        </div>
        </mat-card-actions>
    </mat-card>
</div>
